import { render, staticRenderFns } from "./IntakeBatchChangeOwner.vue?vue&type=template&id=53183e44"
import script from "./IntakeBatchChangeOwner.vue?vue&type=script&lang=ts"
export * from "./IntakeBatchChangeOwner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports